module.exports = __webpack_public_path__ + "img/success2.5c2b73c0.png";